import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_SharedDownload = _resolveComponent("SharedDownload")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('header-content'))
        }, [
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.b('header-title'))
          }, _toDisplayString(_ctx.$t("Загрузка документов")), 3),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('header-subtitle'))
          }, _toDisplayString(_ctx.$t(
              "Фото целиком, без обрезанных краёв и блика. Один документ — один файл"
            )), 3)
        ], 2)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.b('section'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Загрузка паспорта или ВУ*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('passport-uploads'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPassportUploads, (upload) => {
            return (_openBlock(), _createBlock(_component_SharedValidate, {
              key: upload.field,
              field: upload.field,
              value: _ctx.documents[upload.field].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('upload')),
                  document: _ctx.documents[upload.field],
                  "is-preview": false,
                  "is-loading": _ctx.isLoading,
                  "is-readonly": _ctx.isReadonly,
                  "is-error": _ctx.isValidate && !_ctx.documents[upload.field].id,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(upload.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
              ]),
              _: 2
            }, 1032, ["field", "value", "is-validate"]))
          }), 128))
        ], 2)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.b('section'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Загрузка селфи*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('selfie-actions'))
        }, [
          _createVNode(_component_SharedValidate, {
            field: "kyc-personal-documents-selfie",
            value: _ctx.documents['kyc-personal-documents-selfie'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('selfie-upload')),
                document: _ctx.documents['kyc-personal-documents-selfie'],
                "is-preview": false,
                "is-loading": _ctx.isLoading,
                "is-readonly": _ctx.isReadonly,
                "is-center": !_ctx.documents['kyc-personal-documents-selfie'].id,
                "is-label": !!_ctx.documents['kyc-personal-documents-selfie'].id,
                "is-error": 
              _ctx.isValidate && !_ctx.documents['kyc-personal-documents-selfie'].id
            ,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Селфи с документом")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-loading", "is-readonly", "is-center", "is-label", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["value", "is-validate"]),
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.b('selfie-guide', { active: _ctx.isSelfieGuideVisible })),
            type: "button",
            "aria-expanded": _ctx.isSelfieGuideVisible,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleSelfieGuide && _ctx.handleToggleSelfieGuide(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.b('selfie-guide-icon')),
              innerHTML: _ctx.displayedIcons.camera
            }, null, 10, _hoisted_2),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("Какое должно быть селфи")), 1)
          ], 10, _hoisted_1)
        ], 2),
        (_ctx.isSelfieGuideVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.b('selfie-panel'))
            }, [
              _createElementVNode("figure", {
                class: _normalizeClass(_ctx.b('selfie-example'))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass(_ctx.b('selfie-example-image')),
                  src: _ctx.selfieExampleImage,
                  alt: _ctx.$t('Пример селфи с документом')
                }, null, 10, _hoisted_3),
                _createElementVNode("figcaption", null, _toDisplayString(_ctx.$t("Пример")), 1)
              ], 2),
              _createElementVNode("ul", {
                class: _normalizeClass(_ctx.b('selfie-rules'))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedSelfieRules, (rule) => {
                  return (_openBlock(), _createElementBlock("li", { key: rule }, _toDisplayString(_ctx.$t(rule)), 1))
                }), 128))
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.b('agreements'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Скачайте и подпишите соглашения*")), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('section-description'))
        }, _toDisplayString(_ctx.$t(
            "Скачайте файл, подпишите и загрузите обратно — подпись от руки или ЭЦП."
          )), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('agreements-block'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedAgreements, (agreement) => {
            return (_openBlock(), _createElementBlock("div", {
              key: agreement.field,
              class: _normalizeClass(_ctx.b('agreement-card'))
            }, [
              _createElementVNode("h6", {
                class: _normalizeClass(_ctx.b('agreement-title'))
              }, _toDisplayString(_ctx.$t(agreement.title)), 3),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('agreement-steps'))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('agreement-step'))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.b('agreement-stage'))
                  }, _toDisplayString(_ctx.$t("1 · Скачать")), 3),
                  _createVNode(_component_SharedDownload, {
                    class: _normalizeClass(_ctx.b('agreement-download')),
                    document: agreement.document
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(agreement.title)), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "document"])
                ], 2),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.b('agreement-arrow')),
                  innerHTML: _ctx.displayedIcons.arrow
                }, null, 10, _hoisted_4),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('agreement-step'))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.b('agreement-stage'))
                  }, _toDisplayString(_ctx.$t("2 · Загрузить")), 3),
                  _createVNode(_component_SharedValidate, {
                    field: agreement.field,
                    value: _ctx.documents[agreement.field].id,
                    "is-validate": _ctx.isValidate,
                    "is-center": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SharedUpload, {
                        class: _normalizeClass(_ctx.b('agreement-upload')),
                        document: _ctx.documents[agreement.field],
                        "is-loading": _ctx.isLoading,
                        "is-readonly": _ctx.isReadonly,
                        "is-error": _ctx.isValidate && !_ctx.documents[agreement.field].id,
                        onUpload: _ctx.handleUploadFile,
                        onRemove: _ctx.handleRemoveFile
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Подписанное соглашение")), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "document", "is-loading", "is-readonly", "is-error", "onUpload", "onRemove"])
                    ]),
                    _: 2
                  }, 1032, ["field", "value", "is-validate"])
                ], 2)
              ], 2)
            ], 2))
          }), 128))
        ], 2)
      ], 2),
      (_ctx.isOtherShow)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(_ctx.b('other'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('other-title'))
            }, _toDisplayString(_ctx.$t(
            "Пожалуйста, прикрепите иные документы для подтверждения вашей верификации"
          )), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('other-label'))
            }, _toDisplayString(_ctx.$t(
            "Например: документ о происхождении денежных средств, документ подтверждающий постановку на учет в налоговом органе и другие"
          )), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('other-documents'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('other-upload')),
                  document: file,
                  "is-upload": file.isUpload,
                  "is-remove": file.isRemove,
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  onRemove: _ctx.handleRemoveAdditionalFile
                }, _createSlots({ _: 2 }, [
                  (file.name)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.name), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["class", "document", "is-upload", "is-remove", "is-readonly", "is-loading", "onRemove"]))
              }), 128)),
              (_ctx.isAddtionalUpload)
                ? (_openBlock(), _createBlock(_component_SharedUpload, {
                    key: 0,
                    class: _normalizeClass(_ctx.b('other-upload')),
                    document: _ctx.file,
                    "is-upload": _ctx.file.isUpload,
                    "is-readonly": _ctx.isReadonly,
                    "is-loading": _ctx.isLoading,
                    isCenter: true,
                    "is-label": false,
                    onUpload: _ctx.handleUploadAdditionalFile
                  }, null, 8, ["class", "document", "is-upload", "is-readonly", "is-loading", "onUpload"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('file-info'))
      }, [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t("Размер файла")), 1),
        _createTextVNode(" — " + _toDisplayString(_ctx.$t("не более 5 MB.")) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t("Поддерживаемые форматы:")), 1),
        _createTextVNode(" PNG, PDF, JPEG, BMP, HEIC, DOCX, DOC. ")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('verification-block'))
      }, [
        _createVNode(_component_UIButton, {
          class: _normalizeClass(_ctx.b('verification')),
          label: _ctx.displayedVerificationLabel,
          view: "main",
          disabled: _ctx.isVerificationDisabled,
          onClick: _ctx.handleVerification
        }, null, 8, ["class", "label", "disabled", "onClick"]),
        (_ctx.isDisabled && !_ctx.isReadonly)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.b('verification-hint'))
            }, _toDisplayString(_ctx.$t(
            "Кнопка станет активной, когда все обязательные блоки будут отмечены галочкой"
          )), 3))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}